"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _ApiClient = _interopRequireDefault(require("../ApiClient"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Rage+ API
 * API für das Rage+ / VerseNeo Backend der BLB Shops für Edelmetalle und Sorten
 *
 * The version of the OpenAPI document: 1.0.44
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */
/**
 * The KundeLogin model module.
 * @module model/KundeLogin
 * @version 1.0.44
 */
var KundeLogin = /*#__PURE__*/function () {
  /**
   * Constructs a new <code>KundeLogin</code>.
   * Logindaten eines Kunden
   * @alias module:model/KundeLogin
   */
  function KundeLogin() {
    _classCallCheck(this, KundeLogin);
    KundeLogin.initialize(this);
  }

  /**
   * Initializes the fields of this object.
   * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
   * Only for internal use.
   */
  return _createClass(KundeLogin, null, [{
    key: "initialize",
    value: function initialize(obj) {}

    /**
     * Constructs a <code>KundeLogin</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/KundeLogin} obj Optional instance to populate.
     * @return {module:model/KundeLogin} The populated <code>KundeLogin</code> instance.
     */
  }, {
    key: "constructFromObject",
    value: function constructFromObject(data, obj) {
      if (data) {
        obj = obj || new KundeLogin();
        if (data.hasOwnProperty('userLoggedIn')) {
          obj['userLoggedIn'] = _ApiClient.default.convertToType(data['userLoggedIn'], 'Boolean');
        }
        if (data.hasOwnProperty('responseStatus')) {
          obj['responseStatus'] = _ApiClient.default.convertToType(data['responseStatus'], 'String');
        }
        if (data.hasOwnProperty('kundenId')) {
          obj['kundenId'] = _ApiClient.default.convertToType(data['kundenId'], 'Number');
        }
      }
      return obj;
    }

    /**
     * Validates the JSON data with respect to <code>KundeLogin</code>.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @return {boolean} to indicate whether the JSON data is valid with respect to <code>KundeLogin</code>.
     */
  }, {
    key: "validateJSON",
    value: function validateJSON(data) {
      // ensure the json data is a string
      if (data['responseStatus'] && !(typeof data['responseStatus'] === 'string' || data['responseStatus'] instanceof String)) {
        throw new Error("Expected the field `responseStatus` to be a primitive type in the JSON string but got " + data['responseStatus']);
      }
      return true;
    }
  }]);
}();
/**
 * War der Login erfolgreich
 * @member {Boolean} userLoggedIn
 */
KundeLogin.prototype['userLoggedIn'] = undefined;

/**
 * Beschreibung der Login Statsu
 * @member {module:model/KundeLogin.ResponseStatusEnum} responseStatus
 */
KundeLogin.prototype['responseStatus'] = undefined;

/**
 * ID des Kunden
 * @member {Number} kundenId
 */
KundeLogin.prototype['kundenId'] = undefined;

/**
 * Allowed values for the <code>responseStatus</code> property.
 * @enum {String}
 * @readonly
 */
KundeLogin['ResponseStatusEnum'] = {
  /**
   * value: "LOGGED_ON"
   * @const
   */
  "LOGGED_ON": "LOGGED_ON",
  /**
   * value: "NOT_LOGGED_ON"
   * @const
   */
  "NOT_LOGGED_ON": "NOT_LOGGED_ON",
  /**
   * value: "SELECT_ANOTHER_BANK"
   * @const
   */
  "SELECT_ANOTHER_BANK": "SELECT_ANOTHER_BANK",
  /**
   * value: "YES_ERROR_RESPONSE"
   * @const
   */
  "YES_ERROR_RESPONSE": "YES_ERROR_RESPONSE",
  /**
   * value: "UNKNOWN"
   * @const
   */
  "UNKNOWN": "UNKNOWN"
};
var _default = exports.default = KundeLogin;